//DEFINE WHERE IS APP HOSTED
import { getEvnVariable } from "../assembly";

export const URL_ORIGIN_TEXT_APP = process.env.REACT_APP_BASE_TEXT || "";

//DEFINE WHAT API APPLICATION USES
export const getAPIUrl = () =>
  getEvnVariable(
    "REACT_APP_SERVER_URL",
    process.env.REACT_APP_SERVER_URL,
    "https://a.staging.egwwritings.org"
  );

export const getCPanelUrl = () => getEvnVariable("REACT_APP_CPANEL", process.env.REACT_APP_CPANEL);

export const getBaseHost = () => {
  const envValue = getEvnVariable("REACT_APP_BASE_HOST", process.env.REACT_APP_BASE_HOST);

  if ("window" in global) {
    const actualLocationOrigin = window.location.origin;
    // Because Landing Websites have common env-variable {BASE_HOST}
    // (bvc it's single instance for all landings apps, that has common ENV file).
    // Thus base host should be picked from the location, to prevent CORS issues.
    if (!isLocalhost(actualLocationOrigin) && actualLocationOrigin !== envValue) {
      return actualLocationOrigin;
    }
  }

  return envValue;
};

export const getServerToken = () =>
  getEvnVariable("REACT_APP_SERVER_TOKEN", process.env.REACT_APP_SERVER_TOKEN);

export const getTextAppHost = () =>
  getEvnVariable("REACT_APP_TEXT_APP_HOST", process.env.REACT_APP_TEXT_APP_HOST);

export const getNextAppHost = () =>
  getEvnVariable("REACT_APP_NEXT_APP_HOST", process.env.REACT_APP_NEXT_APP_HOST);

export const getSearchLogsUrl = () =>
  getEvnVariable("REACT_APP_SEARCH_LOGS_URL", process.env.REACT_APP_SEARCH_LOGS_URL);

export const getSearchLogsToken = () =>
  getEvnVariable("REACT_APP_SEARCH_LOGS_TOKEN", process.env.REACT_APP_SEARCH_LOGS_TOKEN);

//FIXME workaround before CD/CI update
const nextDomain = "next.";
const textDomain = "text.";
export const getMainAppHost = () => {
  let realMainApp = getEvnVariable("REACT_APP_MAIN_APP_HOST", process.env.REACT_APP_MAIN_APP_HOST);
  let link = realMainApp || getBaseHost() || "";
  if (link.indexOf(nextDomain) !== -1) {
    link = link.split(nextDomain).join("");
  }
  if (link.indexOf(textDomain) !== -1) {
    link = link.split(textDomain).join("");
  }
  return link;
};

export const getClientId = () =>
  getEvnVariable("REACT_APP_CLIENT_ID_AUTHORIZED", process.env.REACT_APP_CLIENT_ID_AUTHORIZED);

export const makeResourceUrl = (url) => {
  let resUrl = getEvnVariable(
    "REACT_APP_RESOURCE_URL",
    process.env.REACT_APP_RESOURCE_URL,
    "https://media2.egwwritings.org"
  );
  return resUrl + url;
};

export const getControlPanelProfile = () => getCPanelUrl() + "/accounts/profile";
export const getSubsAddUrl = () => getCPanelUrl() + "/subscriptions/add";
export const getSubsEditUrl = () => getCPanelUrl() + "/subscriptions";
export const getBackupsUrl = () => getCPanelUrl() + "/studycenter/backups";

export const EXTERNAL_URLS = {
  donate: "https://partner.egwwritings.org/",
  about: "https://whiteestate.org/about/egwbio/",
  oldVersion: "https://legacy.egwwritings.org/",
  oldMobile: "https://m.egwwritings.org",
  oldTextApp: "https://text.egwwritings.org",
  playPitcairn: "https://honor.ellenwhite.org/",
  subscription: getCPanelUrl() + "/accounts/login/?next=/accounts/subscription/",
  faq: "https://ellenwhite.org/faq",

  ellenWhite: "https://ellenwhite.org",
  whiteEstate: "https://whiteestate.org",
  adventistDigitalLibrary: "https://adventistdigitallibrary.org",
  adventistEncyclopedia: "https://encyclopedia.adventist.org/",
  adventistHeritage: "https://www.adventistheritage.org/",

  iosAPP: "https://apps.apple.com/us/app/egw-writings-2/id994076136",
  macOsPKGApp: "https://media4.egwwritings.org/macos/7.8/egw-writings.pkg",
  macOsStoreApp: "https://apps.apple.com/us/app/egw-writings/id1458108029",
  androidApp: "https://play.google.com/store/apps/details?id=com.whiteestate.egwwritings",
  windowsApp: "https://apps.microsoft.com/store/detail/egw-writings/9WZDNCRDBTJ0",
};

/**
 * add process.env.PUBLIC_URL to url.
 * @param {*} url
 */
export const makePublicUrl = (url) => (process.env.PUBLIC_URL || "") + url;

export const placeHolderImage = makePublicUrl("/images/book-placeholder.png");
export const placeHolderImageBig = makePublicUrl("/images/book-placeholder-big.png");
export const folderPlaceholder = makePublicUrl("/images/folder.svg");
export const flagPlaceholder = makePublicUrl("/images/no-flag.svg");
export const avatarPlaceholder = makePublicUrl("/images/avatar.svg");

const categories = ["base", "bible", "apl", "reference"];

export const getPlaceholderImage = (isBig, category = "base") => {
  let validCategory = categories.includes(category) ? category : "base";
  let fileName = validCategory + "" + (isBig ? "-big" : "") + ".png";

  return makePublicUrl("/images/placeholder/" + fileName);
};

export const makeUrlImgBookCoverWithPlaceholder = (bookId, big, category) => {
  if (bookId) {
    const coverLink = big ? "large" : "small";

    // const def =
    //   "&default=" +
    //   encodeURIComponent(
    //     makeImgFeedsUrl(getPlaceholderImage(big, category)),
    //     // (big ? "/covers/book-placeholder-big.png" : "/covers/book-placeholder.png")
    //   );
    // return `${getAPIUrl()}/covers/${bookId}?type=${coverLink}${def}`;
    return `${getAPIUrl()}/covers/${bookId}?type=${coverLink}`;
  } else if (category) {
    return getBaseHost() + "/" + getPlaceholderImage(big, category);
  }
  return big ? placeHolderImageBig : placeHolderImage;
};

export const getUrlImages = () => makePublicUrl("/images");
export const getUrlImagesSignatures = () => getUrlImages() + "/signatures";
export const getUrlImagesAuthors = () => getUrlImages() + "/authors";
export const getUrlImagesBooks = () => getUrlImages() + "/books";
export const getUrlImagesASIBooks = () => getUrlImages() + "/asi";

export const makeUrlImgAuthorSignature = (author, isDarkTheme) => {
  if (author) {
    const fileName = author.replace(/\s/g, "_") + (isDarkTheme ? "-dark" : "-light");
    return getUrlImagesSignatures() + "/" + fileName + ".png";
  }
  return undefined;
};
export const makeUrlImgAuthor = (author) => {
  return getUrlImagesAuthors() + "/" + author + ".png";
};
export const makePathBookImages = (book, imagesSubFolder) => {
  const pathToBookImages = getUrlImagesBooks() + "/" + book.lang + "/" + book.book_id + "/";
  if (imagesSubFolder) {
    return pathToBookImages + imagesSubFolder + "/";
  }

  return pathToBookImages;
};
export const makeUrlImgBookPaper = (book, imagesSubFolder) =>
  makePathBookImages(book, imagesSubFolder) + "paper.png";
export const makeUrlImgBookCover = (book, imagesSubFolder) =>
  makePathBookImages(book, imagesSubFolder) + "cover.png";
export const makeUrlImgBookReflection = (book, imagesSubFolder) =>
  makePathBookImages(book, imagesSubFolder) + "reflection.png";
export const makeUrlImgBookSplash = (splashName) =>
  getUrlImagesBooks() + "/splashes/" + splashName + ".png";
export const makeUrlImgBookASI = (book) => getUrlImagesASIBooks() + "/" + book.book_id + ".png";
export const makeUrlImgASILogo = () => getUrlImagesASIBooks() + "/asi-logo.png";

/**
 * @param {"ios" | "android"} store
 * @returns {string}
 */
export const getUrlImgStore = (store) => {
  return getUrlImages() + "/stores/" + store + ".png";
};

/**
 * @param {"androidTablet" | "SamsungS9" | "imac" | "iPad" | "iPhoneX"} name
 * @returns {string}
 */
export const getUrlImgScreenshot = (name) => {
  return getUrlImages() + "/screenshots/" + name + ".png";
};

export const wrongCoverUrls = new Set();

export const getBookCover = (book, isBig, withDefault) => {
  let coverUrl;
  if (book) {
    let cover = isBig ? book.coverLarge : book.coverSmall;
    if (cover) {
      coverUrl = makeResourceUrl(cover);
    } else if (book.book_id) {
      coverUrl = makeUrlImgBookCoverWithPlaceholder(
        book.book_id,
        isBig,
        book.folder_color_group || book.realType
      );
    }
  }
  if (wrongCoverUrls.has(coverUrl)) {
    return withDefault ? (isBig ? placeHolderImageBig : placeHolderImage) : undefined;
  }

  return coverUrl;
};

export const makeWaveformsJsonUrl = (mp3URL) => {
  return makeResourceUrl(mp3URL.split("#")[0].replace(".mp3", ".json"));
};

//TODO make kebab-case for urls
const routeBibliography = "/bibliography";
export const URLS = {
  home: "/",
  theme: "/getTheme",
  read: "/read",
  myLibrary: "/myLibrary",
  allCollection: "/allCollection",
  adventistBeliefs: "/allCollection/en/1340",
  categories: "/categories",
  titles: "/titles",
  login: "/login",
  logout: "/logout",
  studyCenter: "/studyCenter",
  editorCenter: "/editorCenter",
  thoughts: "/thoughts",
  subscription: "/subscription",
  subscriptionAdd: "/subscriptionAdd",
  subscriptionEdit: "/subscriptionEdit",
  audioBooks: "/audio",
  history: "/history",
  about: "/about",
  settings: "/settings",
  settingsLang: "/settings/lang",
  advSearch: "/advsearch",
  globalSearchResults: "/relatedsearch",
  historySearch: "/search-history",
  featuredSearch: "/featured-search",
  information: "/information",
  languages: "/languages",
  donate: "/donate",
  contactus: "/contactus",
  lessons: "/lessons",
  helpingGuides: "/helping-guides",
  moreAboutUs: "/about",
  book: "/book",
  pdf: "/pdf",
  epub: "/epub",
  aboutEW: "/aboutEW",
  textSearchResults: "/search",
  relatedSearchResults: "/related-search-results",
  answers: "/answers",
  faqSearch: "/faq-search",
  faqSearchReader: "/faq-search-reader",
  searchFilters: "/search-filters", // Textapp only.
  privacyPolicy: "/privacyPolicy",
  copirightNotice: "/legal-copyright-notice",
  userAgreement: "/userAgreement",
  offline: "/offline",
  dictionary: "/dictionary",
  themeMode: "/themeMode",
  faq: "/faq",
  patchNotes: "/patchNotes",
  staticShare: "/static-share",
  loading: "/loading",
  system: "/system",
  bibliography: routeBibliography,
  bibliographyEgw: routeBibliography + "/egw",
  bibliographyBible: routeBibliography + "/bible",
  workspaces: "/workspaces",
  helpTranslate: "/help-translate",
  oidcSignin: "/api/oidc/auth/cb",
  oidcSilentSignin: "/api/oidc/silent",
  oidcSignout: "/api/oidc/logout",

  legacyEbooks: "/ebooks",
  pwaStartURL: "/app",
};

export const AMP_ROUTE = "/amp";

export const URLS_AMP = {
  read: AMP_ROUTE + URLS.read,
};

export const getQueryByName = (name, url, noDecode) => {
  if (!url) {
    return undefined;
  }
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) {
    return undefined;
  }
  if (!results[2]) {
    return "";
  }
  const result = results[2].replace(/\+/g, " ");
  if (noDecode) {
    return result;
  }
  return decodeURIComponent(result);
};

export const parseUrlHash = (url) => {
  const indexHashStart = url.indexOf("#");
  const urlHash = indexHashStart === -1 ? url : url.slice(indexHashStart + 1);
  const arrParams = urlHash.split("&");

  const params = {};
  arrParams.map((p) => {
    const [name, value] = p.split("=");
    params[name] = value;
  });
  return params;
};

export const containsUrl = (str) => str && str.indexOf("http") > -1;

export const withURlProtocol = (url) => (containsUrl(url) ? url : `https://${url}`);

export const isUrlHasHttpPart = (url) => !!url && url.slice(0, 4) === "http";

const isLocalhost = (url) => !!url && url.startsWith("http://localhost");

export const makeLangImage = (code, small = false) => {
  const folder = small ? "flags" : "flags_big";
  return `/images/${folder}/${code}.png`;
};
